import React from "react";
import SportCode from "components/common/SportCode";

export function ScoreContainer(props) {
  const { resultObj } = props;
  const result = resultObj?.result ? resultObj?.result : ''
  const resCode = resultObj?.extra?.resCode ? resultObj?.extra?.resCode : ''
  return (
    <div className='score-result-container d-flex justify-content-end align-self-center'>
      <div className='fw-bold p-0 text-end '>
        {resCode && <SportCode discipline='KTE' code={resCode} entity="@ResultCode" abbr={true} />} {result}
      </div>
    </div>
  )
}